<div class="container-fluid">
    <div class="row">
        <div class="col-md-4 col-lg-3">
            <div class="ibox float-e-margins shadow-lg p-3 mb-5 bg-white rounded">
                <div class="ibox-content">
                    <div class="file-manager">
                        <h5 class="text-center">Directorio Multimedia:</h5>
                        <!--Arbol de directorio-->
                        <div class="container">
                            <app-directory-image (onSelected)="getImages($event.id);directoryIdSelected=$event.id" (onAllDrectories)="allDirectories=$event" />
                        </div>
                        <!--/arbol de directorio-->
                        <hr>
                        <div class="hr-line-dashed"></div>
                        <app-upload-image (onSuccess)="onSuccess($event)"></app-upload-image>
                        <div class="hr-line-dashed"></div>
                        <div class="clearfix"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-8 col-lg-9" style="max-height:800px; overflow: auto;">

            <div id="main-content" class="file_manager">
                <div class="container">
                    <div class="row clearfix">
                        <div class="alert alert-info" *ngIf="!items">No existen imagenes en galeria</div>
                        <div class="col-lg-3 col-md-4 col-sm-6" *ngFor="let item of items">
                            <div class="card">
                                <div class="file">

                                    <div class="dropdown float-end m-1" *ngIf="allDirectories">
                                        <button class="btn   dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">

                                          </button>                                        
                                        <ul class="dropdown-menu">
                                            <li *ngFor="let directory of allDirectories" (mouseover)="mouseOver(directory)" style="cursor: pointer;" (click)="moveImage(item,directory)">
                                                 <a class="dropdown-item">
                                                    <i  [class]="getIconClass(directory)"></i> {{directory?.tag}}</a></li>
                                          </ul>
                                    </div>

                                    <div class="icon">
                                        <img [ngStyle]="{showCursor:'cursor:pointer'}" [src]="domain+'img/upload/'+item.path+'/thumbnail/250_'+item.name"
                                            alt="image" class="img-responsive" (click)="selectedImage(item)">
                                    </div>
                                    <div class="file-name">
                                        <span id="copyLink" class="small">
                                            <div class="btn-group float-end">
                                                <button (click)="copyToClipboard(item)" type="button"
                                                    class="btn btn-sm btn-round btn-icon btn-info">
                                                    <i class="fa fa-clipboard"></i>
                                                </button>

                                                <button (click)="openModal(full,item)" type="button"
                                                    class="btn btn-sm btn-round btn-icon btn-secondary">
                                                    <i class="fa-solid fa-maximize"></i>
                                                </button>
                                                <button (click)="delete(item)" type="button"
                                                    class="btn btn-sm btn-round btn-icon btn-danger">
                                                    <i class="fa fa-trash"></i>
                                                </button>
                                            </div>
                                        </span>
                                        <br>
                                        <div class="input-group mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text">
                                                    alt
                                                </span>
                                            </div>
                                            <input #input id="alt" type="text" class="form-control"
                                                value="{{item.alt}}">
                                            <button type="btn" class="btn btn-inline btn-secondary"
                                                (click)="saveAlt(input.value,item.id)"><i
                                                    class="fa-solid fa-floppy-disk"></i></button>
                                        </div>
                                        <small class="date text-muted">Tamaño: {{item.size}} <br>
                                            Subido
                                            {{item.date}}</small>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>
            </div>


        </div>
    </div>
</div>
<ng-template #full let-c="close" let-d="dismiss">
    <div class="modal-header">
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <img class="center" [src]="pathFull" style="width: 100%;" />
    </div>
</ng-template>